import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M4.864 5.033a.667.667 0 0 0 0 1.334h2a.667.667 0 0 0 0-1.334zM4.198 8.033c0-.368.298-.667.666-.667h2a.667.667 0 1 1 0 1.334h-2a.667.667 0 0 1-.666-.667M4.864 9.7a.667.667 0 1 0 0 1.333h2a.667.667 0 0 0 0-1.333z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9.53 3.7v9.333h3.334V6.366c0-.116-.065-.288-.221-.445-.157-.156-.329-.221-.446-.221h-1.333a.667.667 0 1 1 0-1.334h1.333c.55 0 1.045.269 1.389.612.343.344.611.838.611 1.388v6.667a.667.667 0 0 1 0 1.334H2.199a.667.667 0 1 1 0-1.334V3.7c0-.55.268-1.045.611-1.388.344-.344.838-.612 1.389-.612H7.53c.55 0 1.044.268 1.388.612s.612.838.612 1.388m-6 0c0-.117.066-.289.222-.445.157-.157.329-.222.446-.222H7.53c.116 0 .289.065.445.222.157.156.222.328.222.445v9.333H3.53z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10.198 8.367c0-.369.298-.667.666-.667h.667a.667.667 0 1 1 0 1.333h-.667a.667.667 0 0 1-.667-.666M10.864 9.7a.667.667 0 1 0 0 1.333h.667a.667.667 0 0 0 0-1.333z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })